import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M172.309-103.848q-30.308 0-51.308-21t-21-51.307v-335.383q0-30.307 21-51.307 21-21 51.308-21h87.692v-200q0-30.307 21-51.307 21-21 51.308-21h455.382q30.308 0 51.308 21t21 51.307v335.383q0 30.307-21 51.307-21 21-51.308 21h-87.692v200q0 30.307-21 51.307-21 21-51.308 21H172.309zm0-59.998h455.382q4.616 0 8.463-3.847 3.846-3.846 3.846-8.462v-267.691H160v267.691q0 4.616 3.846 8.462 3.847 3.847 8.463 3.847zm527.69-272.308h87.692q4.616 0 8.463-3.846 3.846-3.846 3.846-8.462v-267.692H320v132.309h307.691q30.308 0 51.308 21t21 51.307v75.384z"
      ></path>
    </svg>
  );
}

export default Icon;
